
const TranslationEngine = ({
  title,
  handleDomainClick,
  isLoading1,
}) => {
  return (
    <>
      <div
        id="translation-engine-container"
        className="relative text-center"
      >
        <div id="translation-engine-button-container">
          <button
            id="translation-engine-button"
            name="translationEngine.execute"
            data-testid="translation-engine-button"
            type="button"
            className="text-3xl px-6 py-3 mt-2 bg-blue-300 font-semibold text-gray-900 shadow-md ring-1 ring-inset ring-blue-300 hover:bg-blue-100 rounded-lg ml-auto"
            aria-haspopup="true"
            onClick={handleDomainClick}
          >
            {isLoading1
              ? "Processing, Please wait..."
              : title}
          </button>
        </div>
      </div>
    </>
  );
};

export default TranslationEngine;
